import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { ExportFormat, useAnalytics } from '@ecosystem/newron-client-lib';
import { containers } from '@ecosystem/newron-design-system';
import { BaseTimePeriod, MainFilters } from '@services/FiltersTypes';
import { IRootState } from '@state/reducers/Reducers';
import {
  checkIfCountryExist,
  getInitialAppliedCountries,
  isAllFeatureValuesEmpty,
  isAppliedFiltersEqualToSelectedFilters,
  isValidTimeFrameAndPeriod,
} from '@utils/FilterUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import {
  Country,
  FactRevenue,
  FeatureOption,
  FilterKeys,
  Filters,
  FilterTitle,
  getPageTypeWithPageName,
  Option,
  PageName,
  PageType,
  ShareType,
  SubSection,
} from '@utils/pageConfig/Types';
import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkPeriodExist, getPeriodicityForMATAndYTD, getPeriodMeta } from '@utils/PeriodUtils';
import getComparisonPeriod from '@components/filter-selection-note/GetComparisonPeriod';
import { SalesPerformance } from '@models/SalesPerformance';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { ProductType } from '@pages/product-analyzer/Product';
import { useToastMessage } from '@components/toast-message/ToastMessage';
import {
  CategoryLeaderboardGroupingPgKpi,
  CategoryLeaderboardParam,
  CategoryLeaderboardPg,
  CategoryLeaderboardPgPage,
  ColumnHeaderDisplayNameForCL,
  ColumnHeaderForCL,
  PageRequest,
} from '@models/CategoryLeaderboard';
import { SortingOptions } from '@components/design/migrated/Table/Sorting/types';
import {
  PAGE_VIEW_TRACKING_TITLE,
  pageViewTrackingFunction,
  PageViewTrackingFunctionParam,
} from '@utils/page-analytics/model/PageViewedTracking';
import { MainFiltersState } from '@state/reducers/main-filter/MainFiltersReducer';
import { GroupContext } from '@utils/userPreferencesUtils/Types';
import { getRetailerDefaultCountryCode } from '@components/multi-banner-retailer-selector/MultiBannerRetailerSelectorUtils';
import {
  useCategoryLeaderboardGroupState,
  useFeatureLeaderboardGroupState,
} from '@utils/hook/userPreferences/UseGroupState';
import { ErrorTagEnum, useSaveErrorLog } from '@utils/LogUtil';
import axios from 'axios';
import {
  PAGE_ELEMENT_CLICK_TRACKING_TITLE,
  pageElementClickTrackingFunction,
  PageElementClickTrackingParam,
  TOGGLE_CLICKED_TITLE,
} from '@utils/page-analytics/model/PageElementClickedTracking';
import { EXPLORE_CARD_TITLE, EXPLORE_LEADERBOARD_CARD_TITLE } from '@pages/Utilities';
import PerformanceSegments from '@components/performance-segments/PerformanceSegments';
import { TableName } from '@utils/page-analytics/model/TableClickTracking';
import CategoryGroup from '@components/category-leaderboard/CategoryGroup';
import { useChartExport } from '@ecosystem/export-utils';
import { useExportTable } from '@hooks/export/export-table/UseExportTable';
import {
  ExportDoubleBarChartOptions,
  useExportDoubleBarChart,
} from '@hooks/export/export-double-bar-chart/hooks/UseExportDoubleBarChart';
import { useExportContext } from '@hooks/export/context/ExportContext';
import {
  dataExportedTrackingFunction,
  DataExportTrackingElementParam,
  useDataExportTracking,
} from '@utils/page-analytics/model/DataExportTracking';
import { ElementType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';
import { getExportTrackingFormat } from '@hooks/export/export-tracking/ExportTracking';
import {
  displayExportErrorToastMessage,
  getAppliedFiltersText,
  getKpiDisplayNameFromHeaderKey,
} from '@hooks/export/ExportUtils';
import { filterByAccessibleProductGroup } from '@utils/collectionUtils/CollectionUtils';
import {
  getCategoryLeaderboardColumns,
  getCategoryLeaderboardOptions,
  getKPIs,
} from '@components/category-leaderboard/category-leaderboard-table-columns/CategoryLeaderboardTableColumns';
import { CollectionDataType } from '@ecosystem/newron-client-collections/build/shared/types';
import { CategoryLeaderboardDoubleBarChartInsight } from '@components/collections/category-leaderboard-double-bar-chart/Model';
import { CreateInsightDataFn } from '@ecosystem/newron-client-collections';
import { CategoryLeaderboardActionBar } from '@components/category-leaderboard/category-leaderboard-group/CategoryLeaderboardActionBar';
import { CreateCategoryOrSegmentsLeaderboardModalGroup } from '@components/category-leaderboard/category-leaderboard-group/create-group/CreateCategoryOrSegmentsLeaderboardModalGroup';
import { DeleteCategoryOrSegmentsLeaderboardModalGroup } from '@components/category-leaderboard/category-leaderboard-group/delete-group/DeleteCategoryOrSegmentsLeaderboardModalGroup';
import { CATEGORY_FEATURE_OPTION, getFeatureSelector } from '@utils/hook/selector/ShowPerformanceWithinSelector';
import { FeatureSelectorType } from '@components/feature-selector/Types';
import { getExploreLeaderboard } from '@services/explore/Explore.service';
import { bindActionCreators } from 'redux';
import { actionCreators, actionCreatorsMarketPremium } from '@state/Index';
import usePersistedSorting from '@utils/hook/sorting/UsePersistedSorting';
import { defaultSortingOptions, SegmentationChart } from '@data-visualization/performance-segment-chart/Types';
import { getDisplayNameFromHeaderKey } from '@models/PerformanceAnalysisboard';
import ListBoxSelector from '@components/button-menu/ListBoxSelector';
import { getGrandTotalValue, GRAND_TOTAL } from '@utils/TotalUtils';
import ExploreHeaderIcon from '@pages/explore/header-icon/ExploreHeaderIcon';
import { ExploreTabView } from '@components/tab-nav/TabConfig';
import { ViewType } from '@hooks/export/Model';
import MarketPerformancePosFactsTiles from '@components/market-performance-pos-facts-tiles/MarketPerformancePosFactsTiles';
import CategoryOrSegmentsLeaderboardGroupProvider from '@components/category-leaderboard/utils/CategoryOrSegmentsLeaderboardGroupProvider';
import { LeaderboardDoubleBarChart, LeaderboardTable } from '@utils/exploreUtils/ExploreType';
import { LimitPgInfo } from '@pages/LimitPgInfo';
import { getFilteredFeatureValues } from '@utils/FilterFeatureFromDropdown';
import { ShareCategoryOrSegmentsLeaderboardModalGroup } from '@components/category-leaderboard/category-leaderboard-group/share-group/ShareCategoryOrSegmentsLeaderboardModalGroup';
import { ExploreViewState } from '@models/SavedViews';
import { RetailerClient } from '@models/RetailerClient';
import useLimitProductGroup from '@utils/hook/explore/UseLimitProductGroup';
import { setApiErrorState } from '@services/utils/ErrorHandlers';

interface Props {
  periodicity: Periodicity;
  period: BaseTimePeriod;
  comparisonPeriod: RelativePeriod | BaseTimePeriod;
  appliedCountries: Option[];
  selectedCountries: Option[];
  appliedProductGroups: Option[];
  defaultFilters: MainFilters[];
  selectedGrowthType: GrowthTypes;
  setGrowthOption: (growthType: GrowthTypes) => void;
  effectiveProductType: ProductType;
  groupingEffect: boolean;
  setGroupingEffect: Dispatch<React.SetStateAction<boolean>>;
  isTableView: boolean;
  setIsTableView: Dispatch<SetStateAction<boolean>>;
  currentSortingOption: SortingOptions;
  setCurrentSortingOption: Dispatch<SetStateAction<SortingOptions>>;
  feature: FeatureOption;
  setFeature: Dispatch<SetStateAction<FeatureOption>>;
  selectedShareType: ShareType;
  setSelectedShareType: Dispatch<SetStateAction<ShareType>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  queryCountries: Country[];
  allFeatureValues: Filters[];
  factRevenue: FactRevenue;
  volume: string;
  revenuePerformance: SalesPerformance;
  volumePerformance: SalesPerformance;
  loadingPosFacts: boolean;
  isFetchingCardApi: boolean;
  saveViewFilter: ExploreViewState;
  retailerClients: RetailerClient[];
  isApiError: boolean;
  setIsApiError: Dispatch<SetStateAction<boolean>>;
}

const { Card } = containers;

export const getGroupedDataRowsForExport = (response: CategoryLeaderboardPgPage): CategoryLeaderboardPg[] => {
  return (response.groupingKpis ?? []).reduce<CategoryLeaderboardPg[]>((acc, group) => {
    acc.push(...group.groupKpis.filter((groupKpi) => groupKpi.segmentOrPg !== GRAND_TOTAL));
    return acc;
  }, []);
};

/**
 * @return ExploreLeaderboardPg object for grouping export excel
 *
 * @remarks
 * To construct an explore leaderboard pg for grouping excel when grouping kpis is empty
 * (meaning inside group got no pgs) and needed to display as blank in Excel file
 * **/
const constructExploreLeaderboardPgForGroupingExcel = (grouping: string): CategoryLeaderboardPg => {
  return {
    segmentOrPg: 'GRAND_TOTAL',
    marketRevenue: { value: null!, actual: null!, percentage: null! },
    marketPrice: { value: null!, actual: null!, percentage: null! },
    yourPrice: { value: null!, actual: null!, percentage: null! },
    marketVolume: { value: null!, actual: null!, percentage: null! },
    yourRevenueMix: { growthPercentage: null!, sharePercentage: null! },
    yourRevenue: { value: null!, actual: null!, percentage: null! },
    marketExcludeRetailRevenue: { value: null!, actual: null!, percentage: null! },
    marketExcludeRetailVolume: { value: null!, actual: null!, percentage: null! },
    marketExcludeRetailPrice: { value: null!, actual: null!, percentage: null! },
    yourVolume: { value: null!, actual: null!, percentage: null! },
    yourRevenueShare: { growthPercentage: null!, sharePercentage: null! },
    yourVolumeShare: { growthPercentage: null!, sharePercentage: null! },
    yourVolumeMix: { growthPercentage: null!, sharePercentage: null! },
    grouping,
  };
};

/**
 * @return array of CategoryLeaderboardPg containing TOTAL KPI of pgs and TOTAL KPI of groups
 *
 * @param dataForExport - response data for Explore leaderboard api
 *
 * @remarks
 * to get array of TOTAL for pgs and groups for summary data for export excel so that it becomes sticky row on
 * top of Excel
 * - first to set a default group kpis if the group kpis is empty so that to display kpi value as blank
 *   in the export excel
 * - then filter grouping kpis TOTAL and replace the TOTAL name to group name and assign it to groupsKpis
 *   variable
 * - then map to get all groups TOTAL by filter out product groups KPIs and assign it to groupsTotal variable
 * **/
export const getSummaryDataRowsForExcel = (dataForExport: CategoryLeaderboardPgPage): CategoryLeaderboardPg[] => {
  const groupsWithEmptyKpis: CategoryLeaderboardGroupingPgKpi[] = dataForExport.groupingKpis.filter((group) =>
    group.groupKpis.length === 0
      ? group.groupKpis.push(constructExploreLeaderboardPgForGroupingExcel(group.groupDetails.groupName))
      : group.groupKpis,
  );

  // Edge case when groupName is equal to segmentOrPg
  const groupsTotal: CategoryLeaderboardPg[] = [];
  for (const group of groupsWithEmptyKpis) {
    const groupTotal = group.groupKpis.find((pgKpis) => pgKpis.segmentOrPg === getGrandTotalValue())!;
    groupTotal.segmentOrPg = group.groupDetails.groupName;
    groupsTotal.push(groupTotal);
  }

  return [...dataForExport.leaderboardKpis.content.slice(0, 1), ...groupsTotal];
};

const Leaderboard: React.FC<Props> = ({
  periodicity,
  period,
  comparisonPeriod,
  appliedCountries,
  selectedCountries,
  appliedProductGroups,
  defaultFilters,
  selectedGrowthType,
  setGrowthOption,
  effectiveProductType,
  groupingEffect,
  setGroupingEffect,
  isTableView,
  setIsTableView,
  currentSortingOption,
  setCurrentSortingOption,
  feature,
  setFeature,
  selectedShareType,
  setSelectedShareType,
  setIsLoading,
  queryCountries,
  allFeatureValues,
  factRevenue,
  volume,
  revenuePerformance,
  volumePerformance,
  loadingPosFacts,
  isFetchingCardApi,
  saveViewFilter,
  retailerClients,
  isApiError = false,
  setIsApiError,
}) => {
  const pagesConfig = usePageConfig();
  const dispatch = useDispatch();
  const { track } = useAnalytics();

  const { updateMainFilters } = bindActionCreators(actionCreators, dispatch);
  const { updateMainFiltersMarketPremium } = bindActionCreators(actionCreatorsMarketPremium, dispatch);

  const mainFiltersState: MainFiltersState = useSelector((state: IRootState) => state.mainFilters);
  const sideFiltersState = useSelector((state: IRootState) => state.sideFilters);
  const retailerClientState = useSelector((state: IRootState) => state.retailerClient);

  const { showToastMessage } = useToastMessage();
  const defaultPageNumber = 0;
  const defaultTotalPageNumber = 1;
  const defaultPageSize = 20;

  const [exploreLeaderboardPg, setExploreLeaderboardPg] = useState<CategoryLeaderboardPg[]>([]);

  const [exploreLeaderboardGroups, setExploreLeaderboardGroups] = useState<CategoryLeaderboardGroupingPgKpi[]>([]);
  const [loadingExploreLeaderboard, setLoadingExploreLeaderboard] = useState<boolean>(true);
  const [doPreserveSelections, setDoPreserveSelections] = useState(false);

  const [isFetchingTableApi, setIsFetchingTableApi] = useState<boolean>(false);
  const CURRENT_TOTAL_NAME = getGrandTotalValue();
  const createViewState = useCallback(() => saveViewFilter, [saveViewFilter]);
  const saveErrorLog = useSaveErrorLog();

  useEffect(() => {
    //Start Page View Amplitude Tracking
    //Update page viewing
    const trackingParam: PageViewTrackingFunctionParam = {
      eventTitle: PAGE_VIEW_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      retailerClientState: retailerClientState,
      track: track,
      pageType: PageType.EXPLORE, // Won't get from redux because of async. RO & CL page sharing the same pageType in pagesConfig
      pageName: PageName.EXPLORE, // Won't get from redux because of async
      access: pagesConfig.access,
      subSection: SubSection.EXPLORE_LEADERBOARD,
      initialLocationId: getInitialAppliedCountries(pagesConfig, PageType.EXPLORE, effectiveProductType),
    };

    pageViewTrackingFunction(trackingParam);
    setGrowthOption(mainFiltersState.selectedGrowthType);
    pagesConfig.setIsNavigateFromRS(true);
    pagesConfig.setIsHidePGInfoWarning(false);
    pagesConfig.setClearFilters(false);
    pagesConfig.setSelectedTimePeriod(period);

    setOnPageFirstLoad(false);
  }, []);

  const [currentPage, setCurrentPage] = useState<number>(defaultPageNumber);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [exploreLeaderboardParam, setExploreLeaderboardParam] = useState<CategoryLeaderboardParam>();
  const [exploreLeaderboardTotalSize, setExploreLeaderboardTotalSize] = useState<number>(0); //This state is to store the total size of Leaderboard in order to get all the data while exporting Table/Bar chart
  const [areDependenciesUpdated, setAreDependenciesUpdated] = useState<boolean>(false); //This state group all the dependencies that needed for DATA api call and prevent multiple dependencies triggered.

  const [loadMoreTable, setLoadMoreTable] = useState<boolean>(false);
  const [onPageFirstLoad, setOnPageFirstLoad] = useState<boolean>(true);
  const [totalNumberProductGroups, setTotalNumberProductGroups] = useState<number>(0);
  const [isEditable, setIsEditable] = useState<boolean>(false);

  const isLimitPG = useLimitProductGroup(appliedProductGroups.length, feature);
  const appliedCountry = (): Country | undefined => {
    return pagesConfig.clientCountries.filter((x) => appliedCountries.some((y) => x.id === y.value)).pop();
  };

  const [updatedFeatureFilters, setUpdatedFeatureFilters] = useState<Filters[]>(allFeatureValues);

  const removeFeatureFromDropdown = (currentFeatureValues: Filters[]): Filters[] => {
    return getFilteredFeatureValues(currentFeatureValues, pagesConfig, effectiveProductType);
  };
  const constructFeatureSelectorType = (): FeatureSelectorType => ({
    isDisabled: isFetchingCardApi,
    feature: feature,
    setFeature: setFeature,
    featureFilters: updatedFeatureFilters,
  });

  const context: GroupContext = useMemo(() => {
    return {
      client: retailerClientState.clientName,
      country: getRetailerDefaultCountryCode(retailerClientState, appliedCountries),
    };
  }, [retailerClientState, appliedCountries]);

  const { allGroupsForApiCalls, getCategoryLeaderboardGroups, getNewSortValues } =
    useCategoryLeaderboardGroupState(context);

  const { featureGroupsForApiCalls, getFeatureLeaderboardGroup } = useFeatureLeaderboardGroupState(context);

  const checkValidComparisonPeriod = () => {
    const periodMeta = getPeriodMeta(period.value, comparisonPeriod, periodicity, period.label)!;

    return !(
      periodMeta.comparisonPeriod.toLowerCase().includes('-nan') ||
      periodMeta.comparisonPeriod.toLowerCase().includes('week -1') ||
      periodMeta.comparisonPeriod.toLowerCase().includes('undefined')
    );
  };

  useEffect(() => {
    //Not to show warning message until the table is loaded
    setIsLoading(loadingExploreLeaderboard);
  }, [loadingExploreLeaderboard]);

  useEffect(() => {
    // Reset total page and current page to default number when apply the filters
    setTotalPage(defaultTotalPageNumber);
    setCurrentPage(defaultPageNumber);
    setIsExportButtonDisabled(true);
  }, [pagesConfig.appliedFilters]);

  useEffect(() => {
    const mainFilters = {
      timeFrame: periodicity,
      period,
      comparisonPeriod,
      selectedGrowthType,
      feature,
    };
    updateMainFiltersMarketPremium({
      ...mainFilters,
    });

    const payload = {
      selectedGrowthType: selectedGrowthType,
      ...(feature !== CATEGORY_FEATURE_OPTION && { feature: feature }),
    };

    updateMainFilters(payload);
  }, [feature, selectedGrowthType]);

  const constructExploreLeaderboardParam = (showPerformanceWithin: FeatureOption): CategoryLeaderboardParam => {
    const appliedFilters = [...pagesConfig.appliedFilters[PageType.EXPLORE].selectedFilters];

    return {
      clientId: retailerClientState.clientId,
      productType: effectiveProductType,
      countries: queryCountries,
      productGroup: appliedProductGroups,
      period: period.value,
      comparisonPeriod: comparisonPeriod,
      periodType: periodicity,
      shareType: selectedShareType,
      pageRequest: { page: defaultPageNumber, size: defaultPageSize } as PageRequest,
      sortOption: currentSortingOption,
      growthType: selectedGrowthType,
      appliedFilters: appliedFilters,
      groups:
        showPerformanceWithin.feature === FilterTitle.CATEGORY
          ? allGroupsForApiCalls
          : featureGroupsForApiCalls.filter((x) => x.showPerformanceWithin === showPerformanceWithin.feature),
      showPerformance: showPerformanceWithin.feature,
      dataType: showPerformanceWithin.dataType,
    };
  };

  /*
   * calls leaderboard api and gets it response
   */
  const loadExploreLeaderboard = async (showPerformanceWithin: FeatureOption) => {
    try {
      setIsExportButtonDisabled(true);
      const loadLeaderboardParam = constructExploreLeaderboardParam(showPerformanceWithin);
      setExploreLeaderboardParam(loadLeaderboardParam);
      setLoadingExploreLeaderboard(true);

      const exploreLeaderboardData: CategoryLeaderboardPgPage = await getExploreLeaderboard(loadLeaderboardParam);
      setExploreLeaderboardGroups(
        Array.isArray(exploreLeaderboardData?.groupingKpis) && exploreLeaderboardData.groupingKpis.length > 0
          ? exploreLeaderboardData.groupingKpis
          : [],
      );

      if (
        Array.isArray(exploreLeaderboardData?.leaderboardKpis?.content) &&
        exploreLeaderboardData.leaderboardKpis.content.length > 0
      ) {
        setTotalPage(exploreLeaderboardData.leaderboardKpis.pageable?.totalPage ?? 0);
        setCurrentPage(defaultPageNumber);
        setExploreLeaderboardTotalSize(exploreLeaderboardData.leaderboardKpis.pageable?.totalElements ?? 0);
        setExploreLeaderboardPg(exploreLeaderboardData.leaderboardKpis.content);
        setTotalNumberProductGroups((exploreLeaderboardData.leaderboardKpis.pageable?.totalElements ?? 0) - 1);
      } else {
        setExploreLeaderboardPg([]);
        setTotalNumberProductGroups(0);
      }
    } catch (err: any) {
      if (axios.isCancel(err)) {
        return;
      }
      saveErrorLog(err, 'Explore Leaderboard - Unable to get leaderboard service.', {
        category: ErrorTagEnum.ApiError,
        requestPayload: {
          clientId: retailerClientState.clientId,
          productGroup: appliedProductGroups,
          period: period.value,
          comparisonPeriod: comparisonPeriod,
        },
      });
      setExploreLeaderboardPg([]);
      setApiErrorState(err, setIsApiError);
    } finally {
      setLoadingExploreLeaderboard(false);
      setIsFetchingTableApi(false);
      setIsExportButtonDisabled(false);
      setAreDependenciesUpdated(false);
    }
  };

  const loadExploreLeaderboardGrouping = async () => {
    setIsFetchingTableApi(true);
    setIsExportButtonDisabled(true);
    try {
      const loadLeaderboardParam = constructExploreLeaderboardParam(feature);
      setExploreLeaderboardParam(loadLeaderboardParam);

      const exploreLeaderboardData: CategoryLeaderboardPgPage = await getExploreLeaderboard(loadLeaderboardParam);

      setExploreLeaderboardGroups(
        Array.isArray(exploreLeaderboardData?.groupingKpis) && exploreLeaderboardData.groupingKpis.length
          ? exploreLeaderboardData.groupingKpis
          : [],
      );
    } catch (err: any) {
      if (axios.isCancel(err)) {
        return;
      }
      saveErrorLog(err, 'Explore Leaderboard - Unable to get leaderboard service.', {
        category: ErrorTagEnum.ApiError,
        requestPayload: {
          clientId: retailerClientState.clientId,
          productGroup: appliedProductGroups,
          period: period.value,
          comparisonPeriod: comparisonPeriod,
        },
      });
      setExploreLeaderboardPg([]);
      setApiErrorState(err, setIsApiError);
    } finally {
      setIsExportButtonDisabled(false);
    }
    setIsFetchingTableApi(false);
  };

  const apiTriggeringValidator = () => {
    return (
      isValidTimeFrameAndPeriod(periodicity, period) &&
      appliedProductGroups &&
      checkIfCountryExist(selectedCountries, pagesConfig, effectiveProductType) &&
      !isFetchingTableApi &&
      !onPageFirstLoad &&
      //to not update upon selected filter change
      isAppliedFiltersEqualToSelectedFilters(pagesConfig) &&
      !pagesConfig.isClearAllFilterTriggered &&
      retailerClientState.clientId !== -1 &&
      !getCategoryLeaderboardGroups.isLoading
    );
  };

  const setDataStateToDefault = () => {
    setLoadingExploreLeaderboard(false);
    setLoadMoreTable(false);
    setAreDependenciesUpdated(false);
    setTotalPage(defaultTotalPageNumber);
    setIsExportButtonDisabled(false);
  };

  useEffect(() => {
    const fetchFeatureValues = async () => {
      if (isLimitPG) {
        // reset all data & pagination & dropdown
        const newFeatureFilters = removeFeatureFromDropdown(allFeatureValues);
        setUpdatedFeatureFilters(newFeatureFilters);
        setLoadingExploreLeaderboard(false);
        setExploreLeaderboardPg([]);
        setExploreLeaderboardGroups([]);
        setDataStateToDefault();
        setCurrentPage(defaultPageNumber);
        setExploreLeaderboardTotalSize(0);
        setTotalNumberProductGroups(0);
        setIsExportButtonDisabled(false);
        return;
      }

      //To check if feature values not empty, then not required to call PA board, stack chart and line chart API
      if (!isAllFeatureValuesEmpty(allFeatureValues)) {
        const newFeatureFilters = removeFeatureFromDropdown(allFeatureValues);
        setUpdatedFeatureFilters(newFeatureFilters);

        const showPerformanceWithinOption = getFeatureSelector(newFeatureFilters, feature, [], pagesConfig.pageName);
        setFeature(showPerformanceWithinOption);

        if (pagesConfig.sortingOptions !== currentSortingOption) {
          setExploreLeaderboardPg([]);
        }

        await loadExploreLeaderboard(showPerformanceWithinOption);

        return () => {
          setIsFetchingTableApi(false);
          setLoadingExploreLeaderboard(false);
          setIsExportButtonDisabled(false);
        };
      } else if (allFeatureValues.length > 0 && isAllFeatureValuesEmpty(allFeatureValues)) {
        setDataStateToDefault();
      }
    };
    pagesConfig.setIsCountryChanged(false);
    if (areDependenciesUpdated) {
      fetchFeatureValues();
    } else {
      const newFeatureFilters = removeFeatureFromDropdown(allFeatureValues);
      setUpdatedFeatureFilters(newFeatureFilters);
    }
  }, [areDependenciesUpdated, allFeatureValues]);

  useEffect(() => {
    if (!areDependenciesUpdated && apiTriggeringValidator() && !isAllFeatureValuesEmpty(allFeatureValues)) {
      setAreDependenciesUpdated(true);
    }
    //This is to stop the tables and charts to rerender upon clearing the filters.
    pagesConfig.setIsClearAllFilterTriggered(false);
  }, [
    periodicity,
    period,
    comparisonPeriod,
    pagesConfig.sortingOptions,
    currentSortingOption,
    pagesConfig.sortingOptionsPerformanceAnalysisStackedChart,
    selectedGrowthType,
    allFeatureValues,
    getCategoryLeaderboardGroups.isLoading,
    onPageFirstLoad,
    isFetchingTableApi,
  ]);

  /**
   * @remarks
   * to call leaderboard API for grouping KPIs when grouping data is changed
   * **/
  useEffect(() => {
    const isTimeFrameExist = checkPeriodExist(defaultFilters, queryCountries[0]?.id, periodicity);
    if (!getCategoryLeaderboardGroups.data || !getFeatureLeaderboardGroup.data || !isTimeFrameExist || isLimitPG) {
      return;
    }

    setGroupingEffect(false);

    if (groupingEffect) {
      return;
    }

    (async () => loadExploreLeaderboardGrouping())();
  }, [getCategoryLeaderboardGroups.data, getFeatureLeaderboardGroup.data]);

  const isLastPage = () => {
    return currentPage === totalPage - 1;
  };

  const handleScroll = async () => {
    if (!checkValidComparisonPeriod() || !isTableView) {
      return;
    }
    if (!loadMoreTable && !isLastPage() && appliedCountry()) {
      const pageNumber = currentPage + 1;
      setLoadMoreTable(true);
      const appliedFilters = [...pagesConfig.appliedFilters[PageType.EXPLORE].selectedFilters];

      try {
        const loadScrollLeaderboardParam: CategoryLeaderboardParam = {
          clientId: retailerClientState.clientId,
          productType: effectiveProductType,
          periodType: periodicity,
          period: period.value,
          comparisonPeriod: comparisonPeriod,
          growthType: selectedGrowthType,
          shareType: selectedShareType,
          sortOption: currentSortingOption,
          pageRequest: { page: pageNumber, size: defaultPageSize } as PageRequest,
          countries: queryCountries,
          productGroup: appliedProductGroups,
          appliedFilters: appliedFilters,
          showPerformance: feature.feature,
          dataType: feature.dataType,
        };

        const categoryLeaderboardData = await getExploreLeaderboard(loadScrollLeaderboardParam);

        setExploreLeaderboardPg([...exploreLeaderboardPg, ...categoryLeaderboardData.leaderboardKpis.content]);
        setCurrentPage(pageNumber);
        setLoadMoreTable(false);
      } catch (err: any) {
        setLoadMoreTable(false);
        saveErrorLog(err, 'Explore Leaderboard - paginated request error.', {
          category: ErrorTagEnum.ApiError,
          requestPayload: {
            clientId: retailerClientState.clientId,
            productGroup: appliedProductGroups,
            period: period.value,
            comparisonPeriod: comparisonPeriod,
          },
        });
      }
    }
    if (isLastPage()) {
      setDoPreserveSelections(false);
    }
  };

  const [isExportButtonDisabled, setIsExportButtonDisabled] = useState<boolean>(false);

  const handleViewChange = (view: ViewType) => {
    setIsTableView(view === ViewType.Table);
    handleElementClickTracking(view);
  };

  const handleElementClickTracking = (title: string) => {
    const params: PageElementClickTrackingParam = {
      sideFilters: sideFiltersState.appliedFilters,
      eventTitle: PAGE_ELEMENT_CLICK_TRACKING_TITLE,
      retailerClientState: retailerClientState,
      chartName: EXPLORE_CARD_TITLE,
      optionChosen: title,
      elementName: TOGGLE_CLICKED_TITLE,
      pageType: getPageTypeWithPageName(retailerClientState.pageViewing),
      pageName: retailerClientState.pageViewing,
      access: pagesConfig.access,
      track: track,
      subSection: SubSection.EXPLORE_LEADERBOARD,
    };
    pageElementClickTrackingFunction(params);
  };

  const renderSegments = () => {
    return isLimitPG ? (
      LimitPgInfo()
    ) : (
      <PerformanceSegments
        isLoading={loadingExploreLeaderboard}
        categoryLeaderboardPg={exploreLeaderboardPg}
        selectedGrowthType={selectedGrowthType}
        setIsExportButtonDisabled={setIsExportButtonDisabled}
        factRevenue={factRevenue}
        volume={volume}
        onExportReady={onExportReady}
        featureSelectorType={constructFeatureSelectorType()}
        sortingOptions={currentSortingOption}
        setCurrentSortingOption={setCurrentSortingOption}
        isExplorePage={true}
        shareType={selectedShareType}
        isApiError={isApiError}
      />
    );
  };

  const renderTable = () => {
    return isLimitPG ? (
      LimitPgInfo()
    ) : (
      <CategoryGroup
        isLoading={loadingExploreLeaderboard}
        categoryLeaderboardPg={exploreLeaderboardPg}
        selectedShareType={selectedShareType}
        selectedGrowthType={selectedGrowthType}
        loadMore={loadMoreTable}
        handleScroll={handleScroll}
        countries={{
          dataType: 'COUNTRY',
          feature: 'COUNTRY',
          filterTitle: 'Country',
          filterKey: FilterKeys.COUNTRY,
          options: [
            {
              value: queryCountries[0]?.id,
              label: queryCountries[0]?.name,
            },
          ],
          disabled: false,
        }}
        setIsExportButtonDisabled={setIsExportButtonDisabled}
        factRevenue={factRevenue}
        feature={feature}
        categoryLeaderboardGroups={exploreLeaderboardGroups}
        currentSortingOption={currentSortingOption}
        setCurrentSortingOption={updateSorting}
        context={context}
        volume={volume}
        totalName={CURRENT_TOTAL_NAME}
        isExplorePage={true}
        subSectionForAmplitudeTracking={SubSection.EXPLORE_LEADERBOARD}
        doPreserveSelections={doPreserveSelections}
        isApiError={isApiError}
      />
    );
  };

  //Export Functionalities
  const [invokeExport, onExportReady] = useChartExport();
  const { multipleExportCallbacks } = useExportContext();
  const handleDataExportTrackingFunction = useDataExportTracking('mainFiltersRO');
  const { download: exportDoubleBarChart } = useExportDoubleBarChart();
  const { download: exportTable } = useExportTable([]);

  const handleExportedTracking = (exportFormats: ExportFormat[]) => {
    const dataExportedTrackingParams: DataExportTrackingElementParam = {
      elementType: isTableView ? ElementType.TABLE : ElementType.BAR_CHART,
      elementKpi: ColumnHeaderDisplayNameForCL(volume)[pagesConfig.sortingOptions.headerKey as ColumnHeaderForCL],
      elementSort: pagesConfig.sortingOptions,
      optionChosen: exportFormats.map((format) => getExportTrackingFormat(format)),
    };
    handleDataExportTrackingFunction(dataExportedTrackingParams, dataExportedTrackingFunction);
  };

  /**
   * To handle onChange event of feature selector
   */
  const featureHandler = React.useCallback(() => {
    setAreDependenciesUpdated(true);
    setIsExportButtonDisabled(true);
    setDoPreserveSelections(false);
  }, [allFeatureValues]);

  const onChartDownload = useCallback(
    async (exportFormats: ExportFormat[]): Promise<void> => {
      if (!exploreLeaderboardParam || exploreLeaderboardPg.length <= 0) {
        return;
      }
      const timePeriod = period.label;
      const periodType = getPeriodicityForMATAndYTD(period, periodicity).periodicity;
      const comparisonTimePeriod = getComparisonPeriod(period, periodType, comparisonPeriod);

      // Update categoryLeaderboardParam to call the API again with totalElements received from last call
      const requestPayload: CategoryLeaderboardParam = exploreLeaderboardParam;
      requestPayload.pageRequest.size = exploreLeaderboardTotalSize;

      try {
        const dataForExport: CategoryLeaderboardPgPage = await getExploreLeaderboard(requestPayload, true);

        const groupedData: CategoryLeaderboardPg[] = getGroupedDataRowsForExport(dataForExport);
        const summaryData: CategoryLeaderboardPg[] = getSummaryDataRowsForExcel(dataForExport);
        const data: CategoryLeaderboardPg[] = dataForExport.leaderboardKpis.content.slice(1);
        const selectedKpiOption: Option = {
          label: getKpiDisplayNameFromHeaderKey(pagesConfig.sortingOptions.headerKey, volume),
          value: pagesConfig.sortingOptions.headerKey,
        };
        const appliedFiltersText: string = getAppliedFiltersText(pagesConfig, PageType.EXPLORE);

        if (isTableView) {
          await exportTable({
            exportFormats,
            invokeExport,
            title: EXPLORE_LEADERBOARD_CARD_TITLE,
            appliedCountry: appliedCountries,
            appliedPg: appliedProductGroups,
            data: [...groupedData, ...data],
            summaryData,
            timePeriod,
            comparisonTimePeriod,
            factRevenue: factRevenue,
            periodType,
            showPerformanceWithin: feature.value,
            appliedFiltersText: appliedFiltersText,
            selectedKpi: selectedKpiOption,
            pageName: PageName.EXPLORE,
            pagesConfig: pagesConfig,
            volume: volume,
          });
        } else {
          const options: ExportDoubleBarChartOptions = {
            exportFormats: exportFormats,
            invokeExport: invokeExport,
            title: EXPLORE_LEADERBOARD_CARD_TITLE,
            appliedCountry: appliedCountries,
            appliedProductGroup: appliedProductGroups,
            data: data,
            period: timePeriod,
            comparisonTimePeriod,
            factRevenue: factRevenue,
            periodType: periodType,
            appliedFiltersText: appliedFiltersText,
            selectedKpi: selectedKpiOption,
            multipleChartsExport: multipleExportCallbacks,
            pageName: PageName.EXPLORE,
            volume: volume,
            showPerformanceWithin: feature.value,
            summaryData,
          };
          await exportDoubleBarChart(options);
        }

        handleExportedTracking(exportFormats);
      } catch (err: any) {
        displayExportErrorToastMessage(
          err,
          'Explore Leaderboard - exportTable error.',
          requestPayload,
          showToastMessage,
          saveErrorLog,
        );
        return;
      }
    },
    [
      exploreLeaderboardParam,
      isTableView,
      exploreLeaderboardPg,
      exploreLeaderboardTotalSize,
      multipleExportCallbacks,
      exportTable,
      exportDoubleBarChart,
    ],
  );

  /**
   * Creates insight data for double bar chart.
   * @param collectionDataType Specifies whether to use live data or not. Default is 'live'.
   * @returns Insight data for double bar chart.
   */
  const createDoubleBarChartInsightDataFn: CreateInsightDataFn<CategoryLeaderboardDoubleBarChartInsight> = (
    collectionDataType: CollectionDataType = 'live',
  ) => {
    const kpiSelectionOptions = getKPIs(getCategoryLeaderboardColumns(selectedShareType, volume));
    const selectedKpi =
      kpiSelectionOptions.find((option) => option.value === pagesConfig.sortingOptions.headerKey) ??
      kpiSelectionOptions[0];

    const params = constructExploreLeaderboardParam(feature);

    const { productGroup, appliedFilters } = filterByAccessibleProductGroup(
      params.appliedFilters,
      pagesConfig.pgsByAppliedCountry,
      params.periodType,
      period.value,
      appliedCountries,
      appliedProductGroups,
    );

    return {
      apiParams: {
        clientId: params.clientId,
        productType: params.productType,
        periodType: params.periodType,
        period: params.period,
        comparisonPeriod: params.comparisonPeriod,
        growthType: params.growthType,
        shareType: params.shareType,
        sortOption: params.sortOption,
        pageRequest: params.pageRequest,
        countries: params.countries,
        productGroup: productGroup,
        appliedFilters: appliedFilters,
        showPerformance: feature.feature,
        dataType: feature.dataType,
      },
      selectedGrowthType: selectedGrowthType,
      factRevenue: factRevenue,
      volume: volume,
      selectedKpiOption: selectedKpi,
      collectionDataType: collectionDataType,
      retailerClientName: retailerClientState.clientName,
    };
  };

  //Button Menu Selector
  const { updateOptions } = usePersistedSorting({
    tableId: SegmentationChart,
    defaultSorting: defaultSortingOptions,
  });

  const updateSorting = (sorting) => {
    updateOptions(sorting);
    setCurrentSortingOption(sorting);
    setDoPreserveSelections(true);
  };

  const kpiData = isTableView
    ? getCategoryLeaderboardColumns(selectedShareType ?? ShareType.MarketShare, volume)
    : getCategoryLeaderboardOptions(volume);

  return (
    <CategoryOrSegmentsLeaderboardGroupProvider>
      <div className="pt-6">
        {!onPageFirstLoad && !isTableView && (
          <>
            <MarketPerformancePosFactsTiles
              revenuePerformance={revenuePerformance}
              volumePerformance={volumePerformance}
              selectedGrowthType={selectedGrowthType}
              isLoading={loadingPosFacts}
              factRevenue={factRevenue}
              volume={volume}
              subSectionForAmplitudeTracking={SubSection.EXPLORE_LEADERBOARD}
              isApiError={isApiError}
            />
            <br />
          </>
        )}
        {
          <>
            <Card testId={EXPLORE_LEADERBOARD_CARD_TITLE}>
              <Card.Title title={' '}>
                <Card.Content>
                  <ListBoxSelector
                    isDisabled={isFetchingTableApi || loadingExploreLeaderboard} //NOSONAR typescript:S6606
                    chartName={
                      isTableView ? TableName.EXPLORE_LEADERBOARD_TABLE : TableName.EXPLORE_LEADERBOARD_BAR_CHART
                    }
                    getDisplayName={getDisplayNameFromHeaderKey}
                    factRevenue={factRevenue}
                    sorting={currentSortingOption}
                    kpisConfig={kpiData}
                    updateSorting={updateSorting}
                    featureFilters={updatedFeatureFilters}
                    showPerformanceWithin={feature}
                    featureHandler={featureHandler}
                    featureSelectorType={constructFeatureSelectorType()}
                    volume={volume}
                    setSortByStackedChart={() => {}}
                    isStackedChart={false}
                    tabView={ExploreTabView.Leaderboard}
                    viewType={isTableView ? ViewType.Table : ViewType.BarChart}
                    selectedShareType={selectedShareType}
                    setSelectedShareType={setSelectedShareType}
                  />
                </Card.Content>
                <Card.Title.Actions>
                  <ExploreHeaderIcon
                    onChartDownload={onChartDownload}
                    isExportButtonDisabled={isExportButtonDisabled}
                    volume={volume}
                    createInsightDataFn={createDoubleBarChartInsightDataFn}
                    exploreChartView={
                      isTableView
                        ? ('Leaderboard Table' as LeaderboardTable)
                        : ('Leaderboard Double Bar Chart' as LeaderboardDoubleBarChart)
                    }
                    exploreTabView={ExploreTabView.Leaderboard}
                    onChange={handleViewChange}
                    createViewStateFn={createViewState}
                  />
                </Card.Title.Actions>
              </Card.Title>
              {isTableView ? renderTable() : renderSegments()}
            </Card>
            {!loadingExploreLeaderboard && isTableView && (
              <>
                <CategoryLeaderboardActionBar
                  totalProductGroups={totalNumberProductGroups}
                  context={context}
                  isEditable={isEditable}
                  setIsEditable={setIsEditable}
                  isLimitPG={isLimitPG}
                />
                <CreateCategoryOrSegmentsLeaderboardModalGroup context={context} sortOrder={getNewSortValues} />
                <DeleteCategoryOrSegmentsLeaderboardModalGroup context={context} />
                <ShareCategoryOrSegmentsLeaderboardModalGroup
                  context={context}
                  saveViewFilter={saveViewFilter}
                  retailerClients={retailerClients}
                />
              </>
            )}
          </>
        }
      </div>
    </CategoryOrSegmentsLeaderboardGroupProvider>
  );
};

export default Leaderboard;
